'use strict';

var OLD_CARD_NUMBER_LENGTH = 15,//旧版身份证号码长度
	NEW_CARD_NUMBER_LENGTH = 18,//新版身份证号码长度
	VERIFY_CODE = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'], //18位身份证中最后一位校验码
	VERIFY_CODE_WEIGHT = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];//18位身份证中，各个数字的生成校验码时的权值
var IDCard = function(card){
	if(card && card !== 'undefined' && card !== 'null'){
		card = String(card).replace(/\s/g,'');
		if (OLD_CARD_NUMBER_LENGTH === card.length) {
			// 如果是15位身份证号码，则自动转换为18位
			card = this.convertToNewCardNumber(card);
		}
		this.card = String(card);
	}
};

IDCard.prototype.convertToNewCardNumber = function(oldCard){
	var newCard = oldCard.substr(0,6) + '19' + oldCard.substr(6);
	return (newCard + this.calculateVerifyCode(newCard));
};

IDCard.prototype.calculateVerifyCode = function(str){
	var sum = 0,
		i = 0,
		length = NEW_CARD_NUMBER_LENGTH - 1,
		ch;
	for(; i < length; i++){
		ch = Number(str[i]) * VERIFY_CODE_WEIGHT[i];
		sum = sum + ch;
	}
	return VERIFY_CODE[sum % 11];
};
/**
 * 获取身份证号码中的生日
 * @returns {Date}
 */
IDCard.prototype.getBirthDate = function(){
	return new Date(this.getBirthDayPart());
};

/**
 * 获取身份证号码中的生日
 * @returns String
 */
IDCard.prototype.getBirthDayPart = function(){
	var dateStr = this.card.substring(6, 14);
	return (dateStr.substring(0,4) + '-' + dateStr.substring(4,6) + '-' + dateStr.substring(6,8))
};

export default {
	validate:function(idCard){
		// 不允许身份证号码中带有空格
		// idCard = String(idCard).replace(/\s/g,'');
		var flg = false,
			result = true,
			date = null,
			instance = null;
		if(idCard.length === OLD_CARD_NUMBER_LENGTH || idCard.length === NEW_CARD_NUMBER_LENGTH){
			instance = new IDCard(idCard);
			date = instance.getBirthDate();
			result = result && /^[0-9]{17}/.test(instance.card); //前17位必须为数字
			result = result && instance.calculateVerifyCode(instance.card) == instance.card[NEW_CARD_NUMBER_LENGTH-1];
			result = result && date > new Date('1900-01-01');
			flg = result;
		}
		return flg;
	}
};